var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39309",
    "data-name": "Group 39309",
    transform: "translate(17155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14929",
    "data-name": "Rectangle 14929",
    width: 24,
    height: 24,
    transform: "translate(-17155)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_3_",
    "data-name": "user (3)",
    transform: "translate(-17153.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38776",
    "data-name": "Group 38776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36728",
    "data-name": "Path 36728",
    d: "M17.925,13.575a10.46,10.46,0,0,0-3.99-2.5,6.07,6.07,0,1,0-6.869,0A10.517,10.517,0,0,0,0,21H1.641a8.859,8.859,0,1,1,17.719,0H21A10.432,10.432,0,0,0,17.925,13.575ZM10.5,10.5a4.43,4.43,0,1,1,4.43-4.43A4.435,4.435,0,0,1,10.5,10.5Z",
    transform: "translate(0)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.330a6cb0436805d01312d89811c2f2bd.svg";
export { ForwardRef as ReactComponent };